import { Button, Modal } from 'react-bootstrap';
import React from 'react';

interface IModalReject {
    showModal: boolean;
    setModalData: (args: any) => void;
    updateInvoice: (args: any) => void;
}

export default function ModalInvoiceConfirm({ showModal, setModalData, updateInvoice }: IModalReject) {
    return (
        <Modal show={showModal} onHide={() => setModalData((prev: any) => ({ ...prev, showModal: false }))} centered>
            <Modal.Header closeButton>
                <Modal.Title>Do you want to approve current invoice?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button
                    className="m-0"
                    variant="danger"
                    onClick={() => setModalData((prev: any) => ({ ...prev, showModal: false }))}
                >
                    No
                </Button>
                <Button className="m-0 ml-2" onClick={updateInvoice}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
